<po-loading-overlay
  [hidden]="isHideLoading"
  p-text="Atualizando..."
></po-loading-overlay>
<form #formOrcamento="ngForm">
  <font class="po-font-title po-m-5">Área técnica</font>

  <div class="po-md-10 po-m-5">
    <po-container>
      <po-container>
        <div class="po-font-text-bold">Manutenção do acervo técnico</div>
        <po-divider></po-divider>

        <po-select
          name="comboSeguimento"
          p-label="Seguimento"
          [p-options]="[
            { label: 'Motos', value: 'MOTOS' },
            { label: 'Peças', value: 'PECAS' }
          ]"
          [(ngModel)]="comboSeguimento"
          (p-change)="getAcervo()"
          p-required
        >
        </po-select>

        <po-input
          name="titulo"
          p-label="Título"
          [(ngModel)]="titulo"
          p-required
        >
        </po-input>
        <po-url name="url" p-label="Link" [(ngModel)]="link"> </po-url>
        <po-textarea
          name="descricao"
          p-label="Descrição"
          [(ngModel)]="descricao"
          p-required
        >
        </po-textarea>
      </po-container>
      <po-container>
        <po-button
          class="po-offset-md-5"
          [p-label]="AdcionarAlterar"
          p-type="primary"
          p-icon="po-icon po-icon-plus-circle"
          [p-disabled]="formOrcamento.invalid"
          (p-click)="adcionar()"
        >
        </po-button>
       
      </po-container>
      <po-container>
        <po-table
          p-selectable
          (p-selected)="selectItem($event)"
          (p-unselected)="unselectItem($event)"
          p-single-select
          p-height="200"
          p-hide-columns-manager
          p-sort="true"
          p-auto-collapse
          [p-columns]="columnsAcervo"
          [p-items]="itemsAcervo"
          [p-striped]="true"
          [p-actions]="actions"
        ></po-table>
      </po-container>
    </po-container>
  </div>
</form>
